/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import './MediaVideo.scss';

const MediaVideo = ({
	source, poster, isActive = true, ...rest
}) => {

	const videoPlayerRef = useRef();
	useEffect(() => {

		if (!isActive && videoPlayerRef.current) {

			videoPlayerRef.current.pause();

		}

	}, [ isActive ]);

	return (
		<video className="MediaVideo" ref={videoPlayerRef} poster={poster} {...rest}>
			<source src={source} type="video/mp4" />
		</video>
	);

};

MediaVideo.propTypes = {
	source: PropTypes.string.isRequired,
	poster: PropTypes.string.isRequired,
	isActive: PropTypes.bool
};

export default MediaVideo;
